export const authPageGridSx = {
  flex: 1,
  minHeight: 0,
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  overflow: 'hidden',
  p: '20px',
};
